import React, { useEffect, useState } from 'react';

const TimerPR = ({ initialSeconds, setTimerValue, timerValue }) => {
    const [seconds, setSeconds] = useState(initialSeconds);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setSeconds(prev => {
                if (prev > 0) {
                    return prev - 1;
                } else {
                    clearInterval(intervalId);
                    return 0;
                }
            });

            if (seconds < 1 && timerValue) {
                setTimerValue(0);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setSeconds(initialSeconds);
    }, [initialSeconds]);

    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return (
        <span>
            {days > 0 && `${days}:`}
            {days > 0 || hours > 0 ? `${String(hours).padStart(2, '0')}:` : ''}
            {String(minutes).padStart(2, '0')}:
            {String(remainingSeconds).padStart(2, '0')}
        </span>
    );
};

export default TimerPR;